import React from "react";
import { Activity, AlertTriangle, Camera, ShieldAlert, DoorOpen, Car, Layers } from "lucide-react";

const LAYER_DEFS = [
  { key: "crowd",    label: "Crowd Heatmap",     icon: Activity },
  { key: "alert",    label: "Alert Heatmap",     icon: AlertTriangle },
  { key: "cameras",  label: "Camera Coverage",   icon: Camera },
  { key: "security", label: "Security Incidents", icon: ShieldAlert },
  { key: "exits",    label: "Emergency Exits",   icon: DoorOpen },
  { key: "parking",  label: "Parking Occupancy", icon: Car },
];

export const MapLayerToggles = ({ layers, onChange }) => {
  const toggle = (key) => onChange({ ...layers, [key]: !layers[key] });

  return (
    <div className="panel-elevated p-2 flex flex-col gap-1.5" data-testid="map-layer-toggles">
      <div className="flex items-center gap-1 px-1">
        <Layers className="w-3 h-3 text-muted-foreground" />
        <span className="micro-label">Layers</span>
      </div>
      <div className="flex flex-col gap-1">
        {LAYER_DEFS.map(({ key, label, icon: Icon }) => {
          const on = !!layers[key];
          return (
            <button
              key={key}
              onClick={() => toggle(key)}
              data-testid={`map-layer-${key}`}
              aria-pressed={on}
              className={[
                "flex items-center gap-1.5 px-2 py-1 text-[10px] font-medium tracking-wide border transition-colors text-left",
                on
                  ? "border-[hsl(var(--primary))] text-[hsl(var(--primary))] bg-[hsl(var(--primary)/0.06)]"
                  : "border-border text-muted-foreground hover:text-foreground",
              ].join(" ")}
            >
              <Icon className="w-3 h-3 shrink-0" />
              <span className="truncate">{label}</span>
              <span className={`ml-auto w-1.5 h-1.5 rounded-full ${on ? "bg-[hsl(var(--primary))]" : "bg-[hsl(var(--muted-foreground))]"}`} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MapLayerToggles;
